import type { InsightType } from "@amzn/d16-g-client-deck-builder-typescript-client";
import { useEffect } from "react";

import { TELEMETRY_ID } from "../../constants/telemetry";
import { logWithTakt } from "../../utils/telemetry.utils";

export interface ContentCardShownProps {
    identifier: string | undefined;
    insightType: InsightType;
}

export const useContentCardShown = ({
    identifier,
    insightType,
}: ContentCardShownProps): void => {
    useEffect(() => {
        logWithTakt(TELEMETRY_ID.INSIGHT_CARD, {
            insightType,
            identifier,
        });
    }, [insightType, identifier]);
};
